import { create } from 'zustand';

import type { LoanEligibility } from '@/api/dashboard';

export type LoanInputOption = 'amount' | 'weight';
type UserInputs = {
  selectedOption: LoanInputOption;
  requestedValue: string;
};

type UserStore = {
  inputs: UserInputs;
  appointmentId: string;
  setInputs: (inputs: Partial<UserInputs>) => Promise<void>;
  setAppointmentId: (appointmentId: string) => void;
  ucic: string | null;
  setUCIC: (ucic: string | null) => void;
  reset: () => void;
  toptupData: LoanEligibility;
  setTopupData: (data: Partial<LoanEligibility>) => Promise<void>;
};

const initialTopupData: LoanEligibility = {
  interestAmount: 0,
  maxCreditAmount: 0,
  message: '',
  minimumTopUpAmount: 0,
  totalDeduction: 0,
  totalMaxRequestAmount: 0,
};

export const useUserStore = create<UserStore>()((set) => ({
  inputs: {
    pincode: '',
    selectedOption: 'amount',
    requestedValue: '',
  },
  appointmentId: '',
  ucic: null,
  toptupData: initialTopupData,
  setInputs: async (inputs) =>
    set((state) => ({
      ...state,
      inputs: {
        ...state.inputs,
        ...inputs,
      },
    })),
  setAppointmentId: (appointmentId: string) =>
    set((state) => ({
      ...state,
      appointmentId,
    })),
  setUCIC: (ucic) =>
    set((state) => ({
      ...state,
      ucic,
    })),
  setTopupData: async (data: Partial<LoanEligibility>) =>
    set((state) => ({
      ...state,
      toptupData: {
        ...state.toptupData,
        ...data,
      },
    })),
  reset: () =>
    set(() => ({
      inputs: {
        pincode: '',
        selectedOption: 'amount',
        requestedValue: '',
      },
      appointmentId: '',
      ucic: null, // Reset ucic to null
      toptupData: initialTopupData,
    })),
}));
